import { ArrowLineUpRight } from '@phosphor-icons/react';

export default ArrowLineUpRight;
